export default __webpack_public_path__ + "static/media/user.c2ae723a.svg";